const GiftCredits = require("../components/GiftCredits");
const { connect } = require("react-redux");
const { uploadGiftCreditsCSV } = require("actions/giftcredits");

module.exports = connect(
    state => ({
        isUploading: state.giftcredits.isUploading
    }),
    { uploadGiftCreditsCSV }
)(GiftCredits);



// WEBPACK FOOTER //
// ./src/routes/admin-gift-credits/containers/GiftCredits.js